import React from 'react';
import { Box } from '@chakra-ui/react';

const VideoBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex={0}
    >
      <Box
        as="video"
        autoPlay
        loop
        muted
        playsInline
        position="absolute"
        top="50%"
        left="50%"
        zIndex={0}
        sx={{
          // Mobile: Zoomed out view covering full width
          '@media (max-width: 768px)': {
            width: '125%',
            height: 'auto',
            minHeight: '100%',
            transform: 'translate(-50%, -50%) scale(0.8)',
            objectFit: 'cover',
          },
          // Desktop: Cover entire viewport
          '@media (min-width: 769px)': {
            minWidth: '100%',
            minHeight: '100%',
            width: 'auto',
            height: 'auto',
            transform: 'translate(-50%, -50%)',
            objectFit: 'cover',
          },
        }}
      >
        <source src="/assets/truck.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </Box>
      
      {/* Gradient overlay for better text readability */}
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgGradient="linear(to-b, blackAlpha.600, blackAlpha.400, blackAlpha.600)"
        zIndex={1}
      />
    </Box>
  );
};

export default VideoBackground;

